import React from 'react';
import DashboardWidget from "./DashboardWidget";
import Button from "../common/Button";
import useCurrentShortcut from "../hooks/useCurrentShortcut";

const StudentGameDashboardWidgetUSA = () => {
    const {loadShortcutByUrl} = useCurrentShortcut();

    return (
        <div>
            <h2>Try a game</h2>
            <div className={'ch-dashboard-usa-game'}>
                <DashboardWidget
                    title={
                        <div className="ch-dashboard-title">
                            <span>Ants' Picnic</span>
                        </div>
                    }
                >
                    <div>
                        <p>Use multiplication to send the correct number of ants to capture the food for the nest. Beware
                            the echidna!</p>
                        <div className={'ch-dashboard-usa-game-image'}>
                            <img src={'/images/USAGameWidgetImage.jpg'}  alt='Ants Picnic Screenshot'/>
                        </div>
                    </div>
                    <button className={'ch-button'} onClick={() => window.location.href = "/controlCentre/playGame.action?gameId=291213"}>Play Now</button>
                </DashboardWidget>
            </div>
        </div>
    )
}

export default StudentGameDashboardWidgetUSA;